import React, { useEffect } from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { useQueryClient } from '@tanstack/react-query';
import logoImage from '../assets/logo.avif';
import kakaoImage from '../assets/kakao.webp';
import { getUserData } from '../lib/client';

const AuthPage: React.FC = () => {
  const { redirectUrl } = useLocation().state as {redirectUrl?: string} || {};
  const navigate = useNavigate();
  const { error } = useAuth({redirectUrl});
  const queryClient = useQueryClient();
  const user = getUserData()

  useEffect(() => {
    queryClient.clear();
  }, []);

  useEffect(() => {
    document.body.style.backgroundColor = '#2C7FFF';  
    return () => {
      document.body.style.backgroundColor = '#ffffff';
    }
  }, []);

  if (user) {
    return <Navigate to="/groups" replace />
  }

  // 랜딩 페이지 화면
  return (
    <div className="h-[100svh] flex flex-col items-center justify-center px-4">
      <div className="max-w-md w-full flex flex-col items-center bg-white rounded-2xl px-4 py-12">
        {/* 로고 이미지 */}
        <img 
          src={logoImage} 
          alt="엔빵 로고" 
          className="h-11 mb-12"
        />
        
        {/* 홍보 멘트 */}
        <div className="text-center mb-10">
          <h1 className="text-2xl font-bold mb-4 whitespace-nowrap">
            정산, 이제는 잊으세요!
          </h1>
          <p className="text-gray-600">
            결제 내역을 쌓아두기만 하면<br />
            나중에 원클릭 송금으로 정산 가능해요
          </p>
        </div>

        {/* 카카오 로그인 버튼 */}
        <button 
          onClick={() => {
            window.Kakao.Auth.authorize({
              redirectUri: `${window.location.origin}/auth/kakao-callback`,
              state: redirectUrl || '/',
            })
          }}
          className="select-none w-full bg-[#FEE500] text-[#333333] font-semibold h-14 rounded-xl flex items-center justify-center gap-2"
        >
          <img src={kakaoImage} alt="kakao" className='w-5 h-5' />
          카카오로 3초만에 시작하기
        </button>

        {/* 전화번호로 시작하기 */}
        <div
          className="mt-8 text-sm flex flex-col items-center gap-1"
        >
          <span className='text-gray-600 '>
            카카오 계정이 없으신가요?
          </span>
          <div className='text-gray-800 flex items-center cursor-pointer underline font-semibold' 
            onClick={() => navigate('/auth/phone', { state: { redirectUrl } })}>전화번호로 시작하기
          </div>
        </div>

        {/* 에러 메시지 표시 */}
        {error && (
          <div className="mt-6 w-full bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded" role="alert">
            <p>{error}</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default AuthPage; 